<template>
  <div class="tc-container">
    <ul>
      <li :class="actvIndex == 1 ? 'is-active' : ''" @click="handSelect(1)">
        今日
      </li>
      <li :class="actvIndex == 2 ? 'is-active' : ''" @click="handSelect(2)">
        近七天
      </li>
      <li :class="actvIndex == 3 ? 'is-active' : ''" @click="handSelect(3)">
        本月
      </li>
      <li :class="actvIndex == 4 ? 'is-active' : ''" @click="handSelect(4)">
        本年
      </li>
    </ul>
    <div class="tp-chart" ref="myChart"></div>
  </div>
</template>
<script>
  export default {
    props: {},
    data() {
      return {
        actvIndex: 3,
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        let chartDom = this.$refs.myChart
        let myChart = this.$echarts.init(chartDom)
        var color = ['#0FDE53', '#0AF4FD', '#FF8E2A', '#F73C3C']

        var legend = ['一般', '较大', '重量', '特大重量']

        var seriesData = [
          {
            name: '一般',
            value: 30,
          },
          {
            name: '较大',
            value: 10,
          },
          {
            name: '重大',
            value: 15,
          },
          {
            name: '特别重大',
            value: 23,
          },
        ]

        var option = {
          color: color,

          grid: {
            top: '15%',
            left: 0,
            right: '1%',
            bottom: 5,
            containLabel: true,
          },
          legend: {
            orient: 'vertical',
            top: 'center',
            right: 50,
            textStyle: {
              align: 'left',
              verticalAlign: 'middle',
              rich: {
                name: {
                  color: '#fff',
                  fontSize: 12,
                },
                value: {
                  color: 'rgba(255,255,255,0.5)',
                  fontSize: 10,
                },
                rate: {
                  color: 'rgba(255,255,255,0.9)',
                  fontSize: 10,
                },
              },
            },
            data: legend,
            formatter: (name) => {
              if (seriesData.length) {
                //const item = seriesData.filter((item) => item.name === name)[0]
                return `{name|${name}}`
                // {value| ${item.value}} {rate| ${item.value}%}
              }
            },
          },
          series: [
            {
              name: '需求类型占比',
              type: 'pie',
              center: ['30%', '50%'],
              radius: ['45%', '65%'],
              label: {
                normal: {
                  show: false,
                  position: 'center',
                  formatter: '{value|{c}}\n{label|{b}}',
                  rich: {
                    value: {
                      padding: 5,
                      align: 'center',
                      verticalAlign: 'middle',
                      fontSize: 14,
                    },
                    label: {
                      align: 'center',
                      verticalAlign: 'middle',
                      fontSize: 12,
                    },
                  },
                },
                emphasis: {
                  show: true,
                  textStyle: {
                    fontSize: '12',
                  },
                },
              },
              labelLine: {
                show: false,
                length: 0,
                length2: 0,
              },
              data: seriesData,
            },
          ],
        }

        getDefaultSelected(myChart)

        function getDefaultSelected(myChart) {
          let index = 0
          myChart.dispatchAction({
            type: 'highlight',
            seriesIndex: 0,
            dataIndex: 0,
          })
          myChart.on('mouseover', (e) => {
            if (e.dataIndex !== index) {
              myChart.dispatchAction({
                type: 'downplay',
                seriesIndex: 0,
                dataIndex: index,
              })
            }
          })
          myChart.on('mouseout', (e) => {
            index = e.dataIndex
            myChart.dispatchAction({
              type: 'highlight',
              seriesIndex: 0,
              dataIndex: e.dataIndex,
            })
          })
        }
        myChart.setOption(option)
        window.addEventListener('resize', () => {
          myChart.resize()
        })
      },
      handSelect(i) {
        this.actvIndex = i
      },
    },
  }
</script>
<style lang="scss" scoped>
  @mixin tongy($a) {
    content: '';
    width: 16px;
    display: inline-block;
    height: 3px;
    background: $a;
    margin-right: 8px;
    position: relative;
    bottom: 4px;
  }
  .tc-container {
    ul {
      list-style: none;
      display: flex;
      justify-content: flex-end;
      color: #15a983;
      cursor: pointer;
      li {
        margin-right: 30px;
        white-space: nowrap;
      }
      .is-active {
        border-bottom: 1px solid #ffc600;
        padding-bottom: 7px;
        position: relative;
        color: #fff;
        &::after {
          content: '';
          width: 0;
          height: 0;
          border-bottom: 5px solid #ffc600;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          position: absolute;
          bottom: 0px;
          left: 37%;
        }
      }
    }
    .tp-chart {
      width: 100%;
      height: 15vh;
    }
  }
</style>
